import React, { useState, useRef, useEffect } from "react";
import emailjs from '@emailjs/browser';
import topFlowerImg from "../../assets/images/svg/top_flower.svg";
import yogaGirlImg from "../../assets/images/contact-us/svg/yoga-girls.svg";
import Button from "../common/button/Button";
import CommonHeading from "../common/heading/CommonHeading";

const ContactUs = ({ContactUsREf}) => {
  const form = useRef();
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    message: ''
  });
  const [status, setStatus] = useState({
    loading: false,
    success: false,
    error: false
  });

  useEffect(() => {
    emailjs.init("OzGBPXkfyvKsXgZwO");
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ loading: true, success: false, error: false });

    try {
      await emailjs.sendForm(
        'service_xfp4ye3',
        'template_yyyb0ea',
        form.current,
        'OzGBPXkfyvKsXgZwO'
      );
      
      setStatus({ loading: false, success: true, error: false });
      setFormData({
        firstName: '',
        lastName: '',
        email: '',
        message: ''
      });
    } catch (error) {
      setStatus({ loading: false, success: false, error: true });
    }
  };

  return (
    <>
      <div className="pt-4 py-lg-5 mb-sm-5 position-relative" id="register" ref={ContactUsREf}>
        {/* TOP FLOWER Icon */}
        {/*<img
          className="position-absolute top_flower_mahamantra top_flower_experiences contact_us_top_flower"
          src={topFlowerImg}
          alt="top_flower"
        />*/}
        <div className="container container_modified pt-sm-4" id="register_two">
          <CommonHeading
            heading="CONTACT"
            className="text-orange common_heading_text common_heading_text_brown"
          />
          <h4 className="common_sub_heading text-center pt-1 pb-4 mb-2">
            Get in Touch with us
          </h4>
          <div className="contact_us_bg py-5 px-3 px-sm-5" id="contact">
            <div className="row">
              <div className="col-lg-6">
                <div className="pt-4 pt-sm-5 pt-lg-0 ps-lg-5 text-center text-lg-start sadhak_experience_text_paren pb-lg-4 mb-3">
                  <h6 className="font-lg fw-semibold text-white mb-0 pt-2">
                    Contact Now
                  </h6>
                  {status.success && (
                    <div style={{ backgroundColor: 'var(--dark-yellow)' }} className="text-brown text-center py-3 mt-3 font-xs fw-medium font-['Marko_One']">
                      Thank you for your message! We'll get back to you soon.
                    </div>
                  )}
                  {status.error && (
                    <div style={{ backgroundColor: 'var(--dark-yellow)' }} className="text-brown text-center py-3 mt-3 font-xs fw-medium font-['Marko_One']">
                      Sorry, there was an error sending your message. Please try again.
                    </div>
                  )}
                  <form ref={form} onSubmit={handleSubmit} className="pt-4 pt-lg-3 mt-1">
                    <div className="d-flex">
                      <input
                        type="text"
                        name="firstName"
                        value={formData.firstName}
                        onChange={handleChange}
                        placeholder="First name"
                        required
                        className="w-100 contact_us_input contact_us_input_height border-0 font-xs fw-medium text-dark-gray"
                      />
                      <input
                        type="text"
                        name="lastName"
                        value={formData.lastName}
                        onChange={handleChange}
                        placeholder="Last name"
                        required
                        className="w-100 contact_us_input contact_us_input_height border-0 font-xs fw-medium text-dark-gray last_name_input_space"
                      />
                    </div>
                    <div className="pt-2 mt-1">
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        placeholder="Email"
                        required
                        className="w-100 contact_us_input contact_us_input_height border-0 font-xs fw-medium text-dark-gray"
                      />
                    </div>
                    <div className="pt-2 mt-1">
                      <textarea
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        className="w-100 contact_us_input border-0 font-xs fw-medium text-dark-gray form-control"
                        placeholder="Message"
                        required
                      ></textarea>
                    </div>
                    <div className="pt-1">
                      <Button 
                        title={status.loading ? "Sending..." : "Submit"} 
                        className="w-100" 
                        type="submit"
                        disabled={status.loading}
                      />
                    </div>
                  </form>
                </div>
              </div>
              <div className="col-lg-5 mx-auto">
                <div className="pt-5 w-lg-25 sadhak_experience_img_paren">
                  <img
                    className="pb-3 pb-sm-5 pb-lg-0 w-100"
                    src={yogaGirlImg}
                    alt="yog-girl"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactUs;
